import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import { _reducer as hb1416Tracker } from './hb1416Tracker.reducers';
import hb1416TrackerEpics from './hb1416Tracker.epics';

export const reducer = combineReducers({
  hb1416Tracker,
});

export const epics = combineEpics(hb1416TrackerEpics);

export * from './hb1416Tracker.actions';
export * from './hb1416Tracker.selectors';
